export enum ConversationMessageType {
  UserMessage = 'UserMessage',
  AgentMessage = 'AgentMessage',
  CustomerSuccessMessage = 'CsMessage',
}
